import { Typography } from "@mui/material";
import { ActionsCell } from "../../../Component/Common/Components/DataTable/ActionsCell";
import { DefaultCell } from "../../../Component/Common/Components/DataTable/DefaultCell";
import { VerificationAgencyClientApplication } from "../../../Component/Model/Dto/VerificationAgency/VerificationAgencyClientApplication";
import { ActionType, TableColumn } from "../../../Component/Model/Table/Table";
import { DateFormatter } from "../../../Component/Model/helpers";
import config from "../../../config";

interface ScorecardRows {
    ID: string;
    ReferenceNumber: IApplicationLinkProps;
    ScorecardName: ILinkProps;
    ScorecardType: string;
    CreatedDate: string
    IsConsolidated: string;
    FromDate: string;
    ToDate: string;
    TotalPoints: string;
    RatingLevel: string;
    AdjustmentLevel: string;
    Actions: ActionType[];
}

interface ScorecardTable {
    columns: Array<TableColumn>;
    rows: Array<ScorecardRows>;
}

interface ILinkProps {
    linkTo: string;
    itemName: string;
}

interface IApplicationLinkProps {
    itemId: number;
    itemName: string;
}

function routeToScorecardPage(redirectUrl: string) {
    window.open(redirectUrl, '_blank');
}

export function VAClientScorecardTableMapper(dataObject: VerificationAgencyClientApplication.LinkedScorecardsDto[], vaClientId: number, openViewCertificates: (id: string) => void, deleteScorecard: (id: string) => void, setApplication: (id: number, appId: number) => void,): ScorecardTable {
    const columns = [
        { Header: 'Application Reference', accessor: 'ReferenceNumber', Cell: ({ value }: any) => <Typography variant="caption" fontWeight='regular' color="#007bff" style={{ cursor: "pointer" }} onClick={() => setApplication(value.itemId, value.itemApplicationId)}>{value.itemName}</Typography> },
        { Header: 'Scorecard Name', accessor: 'ScorecardName', Cell: ({ value }: any) => <Typography variant="caption" fontWeight='regular' color="#007bff" component={'span'} onClick={() => routeToScorecardPage(value.linkTo)} style={{ cursor: 'pointer' }}>{value.itemName}</Typography> },
        { Header: 'Scorecard Type', accessor: 'ScorecardType', Cell: ({ value }: any) => <DefaultCell value={value} tooltip={true} /> },
        { Header: 'Created Date', accessor: 'CreatedDate', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Consolidated Scorecard', accessor: 'IsConsolidated', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'From Date', accessor: 'FromDate', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'To Date', accessor: 'ToDate', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Total Points', accessor: 'TotalPoints', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Rating Level', accessor: 'RatingLevel', Cell: ({ value }: any) => <DefaultCell value={value} tooltip={true} maxWidth={"70px"} /> },
        { Header: 'Adjustment Level', accessor: 'AdjustmentLevel', Cell: ({ value }: any) => <DefaultCell value={value} tooltip={true} maxWidth={"70px"} /> },
        { Header: 'Actions', accessor: 'Actions', Cell: ({ value }: any) => <ActionsCell actions={value} />, disableSortBy: true }
    ];
    if (dataObject.length > 0) {
        const rows = dataObject.map((item: VerificationAgencyClientApplication.LinkedScorecardsDto, index: number) => ({

            ID: item.scorecardId,
            ReferenceNumber: { itemId: vaClientId, itemName: item.applicationReferenceNumber, itemApplicationId: item.applicationId },
            ScorecardName: { linkTo: `${config.publicUrl}#scorecard/${item.scorecardId}/dashboard`, itemName: item.scorecardName },
            ScorecardType: item.scorecardType,
            CreatedDate: DateFormatter(item.createdDate.toString()),
            IsConsolidated: item.isConsolidated ? 'Yes' : 'No',
            FromDate: DateFormatter(item.fromDate.toString()),
            ToDate: DateFormatter(item.toDate.toString()),
            TotalPoints: (Math.round(item.totalPoints * 100) / 100).toFixed(2),
            RatingLevel: item.ratingLevel,
            AdjustmentLevel: item.adjustmentLevel,
            Actions: [
                item.hasCertificates ?
                    {
                        key: index.toString(),
                        label: 'View Certificates',
                        action: () => {
                            openViewCertificates(item.scorecardId);
                        },
                        icon: {
                            color: 'primary',
                            name: 'grading'
                        }
                    }
                    :
                    {
                        key: index.toString(),
                        label: `There are no certificates available to download`,
                        action: () => { },
                        icon: {
                            color: 'secondary',
                            name: 'grading'
                        },
                        disabled: true
                    },
                {
                    key: index.toString(),
                    label: 'Delete',
                    action: () => {
                        deleteScorecard(item.scorecardId);
                    },
                    icon: {
                        color: 'error',
                        name: 'delete'
                    }
                }
            ]

        }));
        return { columns: columns, rows: rows };
    }
    else {
        return { columns: columns, rows: [] };
    }
}

